































import {
    GetInvoiceResponse
} from '@/classes/TayehApi/Instance';
import {
    Component,
    Prop,
    Vue
} from 'vue-property-decorator'
import InvoiceViewerHeader from './InvoiceViewerHeader.vue';
import InvoiceViewerInfoTable from './InvoiceViewerInfoTable.vue';
import InvoiceViewerTransactionsTable from './InvoiceViewerTransactionsTable.vue';
import InvoiceViewerDelivery from './InvoiceViewerDelivery.vue';
import InvoiceViewerPrice from './InvoiceViewerPrice.vue';
import InvoiceViewerFooter from './InvoiceViewerFooter.vue';

@Component({
    components: {
        InvoiceViewerHeader,
        InvoiceViewerInfoTable,
        InvoiceViewerTransactionsTable,
        InvoiceViewerDelivery,
        InvoiceViewerPrice,
        InvoiceViewerFooter
    }
})
export default class InvoiceViewer extends Vue {
    @Prop() invoice: GetInvoiceResponse;


    public get invoiceDate(): Date {
        return this.invoice.date?.created || new Date()
    }

}
